import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {InfluenciacompraDetail} from "./influenciacompra-detail";

const InfluenciaCompraDetailPage = React.memo(() => {

    const {id} = useParams();
    let navigate = useNavigate();

    const onClose = () => {
        navigate('/influenciacompras');
    }

    return (
        <InfluenciacompraDetail id={id} onClose={onClose}/>
    )

});

export default InfluenciaCompraDetailPage;